import { v4 as uuidv4 } from 'uuid';

enum EType {
  SUCCESS = 'success',
  INFO = 'info',
  WARNING = 'warning',
  ERROR = 'error',
}

export type TALERT = {
  type: EType;
  message: string;
};

export interface IALERT extends TALERT {
  id: string;
}
/**
 * fetch current alerts
 */
const fetchAlerts = () =>
  localStorage.getItem('alerts') !== null
    ? JSON.parse(localStorage.getItem('alerts'))
    : [];
/**
 *
 * delay time : 3s
 * @return {
 *  setAlert(alertObject) : add new alert
 * getAlert : get current queued alerts
 * emptyAlerts: alerts => []
 * }
 * @usage: const { setAlert} = useAlerts()
 * !:: can be used anywhere cause state is being handled in the current Session storage
 */

export const useAlerts = () => {
  return {
    setAlert: (newAlert: TALERT, toConsole = '') => {
      const newAlertId = { ...newAlert, id: uuidv4() };
      const alerts: IALERT[] = fetchAlerts();
      const msgs = alerts.map(a => a.message);
      if (!msgs.includes(newAlert.message)) {
        alerts.push(newAlertId);
      }
      localStorage.setItem('alerts', JSON.stringify(alerts));
      if (toConsole) {
        consoleMessage(newAlertId);
      }
    },

    getAlerts: () => {
      const currentAlerts: IALERT[] = fetchAlerts();
      return currentAlerts;
    },
    deleteAlert: (currentAlert: IALERT) => {
      const alerts: IALERT[] = fetchAlerts();
      localStorage.setItem(
        'alerts',
        JSON.stringify(alerts.filter(a => a.id !== currentAlert.id))
      );
    },
    emptyAlerts: () => {
      localStorage.setItem('alerts', JSON.stringify([]));
    },
  };
};

function consoleMessage(newAlert: TALERT): void {
  switch (newAlert.type) {
    case EType.SUCCESS: {
      console.log(newAlert.message);
      break;
    }
    case EType.INFO: {
      console.info(newAlert.message);
      break;
    }
    case EType.WARNING: {
      console.warn(newAlert.message);
      break;
    }
    case EType.ERROR: {
      console.error(newAlert.message);
      break;
    }
  }
}
